module.exports = __webpack_public_path__ + "img/full0-min.115c40e3.png";